<template>
  <div>
    <a v-if="isClickAway" target="_blank" rel="nofollow" class="tooltip-new" :href="hyperLink" :data-track="dataTrack">
      <img v-if="v2" :style="{'vertical-align': iconAlign }" src="/static/img/tooltips/v2.svg">
      <template v-else>
        <img v-if="!questionMark && !svgInfoIcon" src="/static/img/tooltips/info.png">
        <img v-if="svgInfoIcon" src="/static/img/home/ic-info.svg">
        <img v-if="questionMark && !svgInfoIcon" src="/static/img/tooltips/group-2115.png"
             srcset="/static/img/tooltips/group-2115@2x.png 2x,
             /static/img/tooltips/group-2115@3x.png 3x"
             class="Group-2115">
      </template>
      <span class="tooltip-text">
        <slot></slot>
      </span>
    </a>
    <a v-else :data-track="dataTrack" :class="['tooltip-new', { 'theme-white' : themeWhite }]">
      <img v-if="v2" src="/static/img/tooltips/v2.svg">
      <template v-else>
        <img :class="{ 'vert-middle': mobileImageAlign }" src="/static/img/tooltips/info.png" v-if="!svgInfoIcon && !themeWhite">
        <img v-if="svgInfoIcon" src="/static/img/home/ic-info.svg">
        <img v-if="themeWhite" class="info-img vert-middle" src="/static/img/new/header/info-white.png"
             srcset="/static/img/new/header/info-white@2x.png 1.5x, /static/img/new/header/info-white@2x.png 2x, /static/img/new/header/info-white@3x.png 3x"/>
      </template>
      <span :style="{'width':contentWidth}" class="tooltip__content-box" :class="`tooltip__content-box--${pos}`">
        <p class="tooltip__content">
          <slot></slot>
        </p>
      </span>
    </a>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'TooltipNew',
  props: {
    v2: {
      type: Boolean,
      default: false
    },
    iconAlign: {
      type: String,
      default: 'bottom'
    },
    dataTrack: {
      type: String,
      default: ''
    },

    contentWidth: {
      type: String,
      default: 'auto'
    },
    questionMark: {
      type: Boolean,
      default: false
    },
    hyperLink: {
      type: String,
      default: ''
    },
    isClickAway: {
      type: Boolean,
      default: false
    },
    mobileImageAlign: {
      type: Boolean,
      default: false
    },
    svgInfoIcon: {
      type: Boolean,
      default: false
    },
    pos: {
      type: String,
      default: 'right'
    },
    themeWhite: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.tooltip-text {
  color: #4d4f5c;
  font-size: 12px;
}
</style>

<style>
.tooltip-new {
  position: relative;
  font-weight: normal;
  height: 17px;
}

img {
  vertical-align: bottom;
}

.tooltip__content-box {
  visibility: hidden;
  opacity: 0;
  background-color: #f3f3f4;
  color: #fff;
  position: absolute;
  transition: opacity 0.3s;
  top: -26px;
  padding: 20px 20px 20px 23px;
  font-size: 11px;
  line-height: 17px;
  z-index: 1;
}

.theme-white > .tooltip__content-box {
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  right: -37px;
}

.tooltip__content-box--right {
  left: 37px;
}

.tooltip__content-box--bottom {
  top: 25px;
}

.tooltip__content-box--left {
  right: 37px;
}

.tooltip__content {
  color: #707070;
}

.theme-white > .tooltip__content-box > p.tooltip__content {
  color: #29357f;
  text-align: center;
}

.tooltip__content-box::after {
  content: "";
  position: absolute;
  top: 25px;
  margin-left: -19px;
  border-width: 10px;
  border-style: solid;
  border-bottom: 10px solid #f3f3f4;
}

.theme-white > .tooltip__content-box::after {
  right: 31px;
  top: -20px;
  border-bottom: 10px solid #fff;
  /* color: #29357f; */
  color: transparent;
}

.tooltip__content-box--right::after {
  left: -1px;
  transform: rotate(270deg);
}

.tooltip__content-box--left::after {
  right: -20px;
  transform: rotate(90deg);
}

/* .tooltip__content-box--bottom::after { */
/*   right: -20px; */
/*   transform: rotate(90deg); */
/* } */

.tooltip-new:hover .tooltip__content-box {
  visibility: visible;
  opacity: 1;
}

.tooltip-new > .Group-2115 {
  width: 17px;
  height: 17px;
  object-fit: contain;
}

.vert-middle {
  vertical-align: middle !important;
}

.info-img {
  width: 10px;
  height: 10px;
  margin-top: -3px;
}

</style>



// WEBPACK FOOTER //
// src/widgets/TooltipNew.vue